export default function useUserProfile(){
  const urlParams = new URLSearchParams(window.location.search);

  return {
    hide: urlParams.get('show-profile') === 'false'
  }
}